import { StorkPermissions } from '@quadminds/shared/commons';
import { AdminPermission, OrganizationPermissions, UsersPermissions } from '../enums';

export type Permission = UsersPermissions | OrganizationPermissions | AdminPermission | StorkPermissions;
